export default Object.freeze({
  apiURL: process.env.VUE_APP_API_URL || 'http://localhost:3333',
})
